import { useMediaQuery } from "@material-ui/core";
import theme from "theme/Theme";

export type HistoryHeightType = {
    compact: number;
    full: number;
};
export const HISTORYCOMMENTMAINHEIGHT: HistoryHeightType = {
    compact: 180,
    full: 200
};
export const HISTORYTAGSAUTOMATIONMAINHEIGHT: HistoryHeightType = {
    compact: 85,
    full: 160
};
export const HISTORYCHANGESTATUSHEIGHT: HistoryHeightType = {
    compact: 220,
    full: 250
};
export const HISTORYSENDEMAILAUTOMATIONHEIGHT: HistoryHeightType = {
    compact: 155,
    full: 195
};
export const HISTORYSENDEMAILAUTOMATIONLATERHEIGHT: HistoryHeightType = {
    compact: 170,
    full: 215
};
export const HISTORYSENDEMAILBULKHEIGHT: HistoryHeightType = {
    compact: 145,
    full: 145
};
export const HISTORYSENDEMAILTOUSERAUTOMATIONHEIGHT: HistoryHeightType = {
    compact: 125,
    full: 185
};
export const HISTORYSENDEMAILTOUSERAUTOMATIONHEIGHTLATER: HistoryHeightType = {
    compact: 140,
    full: 195
};
export const HISTORYADDTOJOBHEIGHT: HistoryHeightType = {
    compact: 110,
    full: 135
};
export const HISTORYAPPLIEDTOJOBHEIGHT: HistoryHeightType = {
    compact: 110,
    full: 135
};
export const HISTORYREMOVEFROMJOBHEIGHT: HistoryHeightType = {
    compact: 95,
    full: 95
};
export const HISTORYREQUESTEVALUATIONHEIGHT: HistoryHeightType = {
    compact: 110,
    full: 150
};
export const HISTORYREQUESTEVALUATIONAUTOMATIONHEIGHT: HistoryHeightType = {
    compact: 165,
    full: 215
};
export const HISTORYOPINIONONTHEAPPLICANT: HistoryHeightType = {
    compact: 200,
    full: 215
};
export const HISTORYCHANGESTAGEASSESSMENTRESULTHEIGHT: HistoryHeightType = {
    compact: 190,
    full: 190
};
export const HISTORYSENDASSESSMENTHEIGHT: HistoryHeightType = {
    compact: 100,
    full: 150
};
export const HISTORYJOBMATCH: HistoryHeightType = {
    compact: 150,
    full: 150
};

export interface IApplicantHistoryProps {
    historyItem: Compleo.IObject;
    setModalCommentOpen: React.Dispatch<
        React.SetStateAction<{
            open: boolean;
            editData?: {
                commentId: string;
                historyData: Compleo.IObject;
            };
        }>
    >;
    tLocal: any;
    language: string;
    readOnly?: boolean;
}

export const getIconByHistoryType = (
    historyType: CompleoShared.Common.ApplicantHistoryType
) => {
    switch (historyType) {
        case "changeJobStage":
        case "changeJobStageAssessmentResult":
        case "changeJobApplicantMatchResult":
            return "swap_horiz";
        case "addComment":
            return "comment";
        case "addTagsAutomation":
        case "addTagsBulk":
            return "label";
        case "addToJob":
            return "work";
        case "appliedForTheJob":
            return "work";
        case "removedFromJob":
            return "delete";
        case "sendEmailAutomation":
            return "mail";
        case "sendEmailAutomation_later":
            return "access_alarm";
        case "sendEmailToUsersAutomationApplicantContext":
            return "contact_mail";
        case "sendEmailToUsersAutomationApplicantContext_later":
            return "access_alarm";
        case "sendEmailBulk":
            return "mail";
        case "requestEvaluation":
        case "requestEvaluationAutomation":
            return "star";
        case "phoneCall":
            return "phone";
        case "interview":
            return "event_seat";
        case "textMessage":
            return "message";
        case "termsOfServiceAccepted":
            return "check_circle";
        case "newOrUpdateApplicantOpinion":
        case "newOrUpdateApplicantOpinionJob":
            return "announcement";
        case "sendAssessment":
        case "sendAssessmentAutomation":
        case "sendAssessmentAutomation_emailAgain":
        case "sendAssessment_emailAgain":
        case "sendAssessmentAutomation_failedApplicantAssessmentCompleted":
        case "sendAssessment_failedApplicantAssessmentCompleted":
            return "assessment";
        case "jobApplicantMatch":
        case "jobApplicantMatchAutomation":
            return "stars";
        default:
            return "fiber_manual_record";
    }
};

export const getColorByHistoryType = (
    historyType: CompleoShared.Common.ApplicantHistoryType
) => {
    switch (historyType) {
        case "changeJobStage":
        case "changeJobStageAssessmentResult":
        case "changeJobApplicantMatchResult":
            return "#f44336";
        case "addComment":
            return "#3f51b5";
        case "addTagsAutomation":
        case "addTagsBulk":
            return "#26a69a";
        case "addToJob":
            return "#2196f3";
        case "appliedForTheJob":
            return "#2196f3";
        case "removedFromJob":
            return "#f44336";
        case "sendEmailAutomation":
            return "#26a69a";
        case "sendEmailAutomation_later":
            return "#26a69a";
        case "sendEmailToUsersAutomationApplicantContext":
            return "#26a69a";
        case "sendEmailToUsersAutomationApplicantContext_later":
            return "#26a69a";
        case "sendEmailBulk":
            return "green";
        case "requestEvaluation":
            return "#fbc02d";
        case "requestEvaluationAutomation":
            return "#26a69a";
        case "phoneCall":
            return "red";
        case "interview":
            return "indigo";
        case "termsOfServiceAccepted":
            return "#26a69a";
        case "newOrUpdateApplicantOpinion":
        case "newOrUpdateApplicantOpinionJob":
            return "#3f51b5";
        case "sendAssessment":
        case "sendAssessmentAutomation":
        case "sendAssessmentAutomation_emailAgain":
        case "sendAssessment_emailAgain":
            return "#00e5ff";
        case "sendAssessmentAutomation_failedApplicantAssessmentCompleted":
        case "sendAssessment_failedApplicantAssessmentCompleted":
            return "red";
        case "jobApplicantMatch":
        case "jobApplicantMatchAutomation":
            return "#33eb91";
        default:
            return "grey";
    }
};

export const useGetSizeByHistoryType = () => {
    const bigScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const getReturnType = () => {
        return bigScreen ? "compact" : "full";
    };
    const historySizeType: "full" | "compact" = getReturnType();

    const getSizeByHistoryType = (
        historyType: CompleoShared.Common.ApplicantHistoryType
    ) => {
        switch (historyType) {
            case "changeJobStage":
                return HISTORYCHANGESTATUSHEIGHT[historySizeType];
            case "changeJobStageAssessmentResult":
                return HISTORYCHANGESTAGEASSESSMENTRESULTHEIGHT[
                    historySizeType
                ];
            case "addComment":
            case "interview":
            case "phoneCall":
                return HISTORYCOMMENTMAINHEIGHT[historySizeType];
            case "addTagsAutomation":
            case "addTagsBulk":
                return HISTORYTAGSAUTOMATIONMAINHEIGHT[historySizeType];
            case "addToJob":
                return HISTORYADDTOJOBHEIGHT[historySizeType];
            case "appliedForTheJob":
                return HISTORYAPPLIEDTOJOBHEIGHT[historySizeType];
            case "removedFromJob":
                return HISTORYREMOVEFROMJOBHEIGHT[historySizeType];
            case "sendEmailAutomation":
                return HISTORYSENDEMAILAUTOMATIONHEIGHT[historySizeType];
            case "sendEmailAutomation_later":
                return HISTORYSENDEMAILAUTOMATIONLATERHEIGHT[historySizeType];
            case "sendEmailToUsersAutomationApplicantContext":
                return HISTORYSENDEMAILTOUSERAUTOMATIONHEIGHT[historySizeType];
            case "sendEmailToUsersAutomationApplicantContext_later":
                return HISTORYSENDEMAILTOUSERAUTOMATIONHEIGHTLATER[
                    historySizeType
                ];
            case "sendEmailBulk":
                return HISTORYSENDEMAILBULKHEIGHT[historySizeType];
            case "requestEvaluation":
                return HISTORYREQUESTEVALUATIONHEIGHT[historySizeType];
            case "requestEvaluationAutomation":
                return HISTORYREQUESTEVALUATIONAUTOMATIONHEIGHT[
                    historySizeType
                ];
            case "newOrUpdateApplicantOpinion":
            case "newOrUpdateApplicantOpinionJob":
                return HISTORYOPINIONONTHEAPPLICANT[historySizeType];
            case "sendAssessment":
            case "sendAssessmentAutomation":
            case "sendAssessmentAutomation_emailAgain":
            case "sendAssessment_emailAgain":
            case "sendAssessmentAutomation_failedApplicantAssessmentCompleted":
            case "sendAssessment_failedApplicantAssessmentCompleted":
                return HISTORYSENDASSESSMENTHEIGHT[historySizeType];
            case "jobApplicantMatch":
            case "jobApplicantMatchAutomation":
                return HISTORYJOBMATCH[historySizeType];
            default:
                return HISTORYCHANGESTATUSHEIGHT[historySizeType];
        }
    };
    return { getSizeByHistoryType, historySizeType };
};

export const applicantHistoryTypeList: CompleoShared.Common.ApplicantHistoryType[] = [
    "addTagsAutomation",
    "sendEmailAutomation",
    "sendEmailAutomation_later",
    "addTagsBulk",
    "sendEmailBulk",
    "removedFromJob",
    "addToJob",
    "appliedForTheJob",
    "addComment",
    "changeJobStage",
    "sendEmailToUsersAutomationApplicantContext",
    "sendEmailToUsersAutomationApplicantContext_later",
    "requestEvaluation",
    "requestEvaluationAutomation",
    "phoneCall",
    "interview",
    "textMessage",
    "termsOfServiceAccepted",
    "newOrUpdateApplicantOpinion",
    "newOrUpdateApplicantOpinionJob",
    "changeJobStageAssessmentResult",
    "sendAssessment",
    "sendAssessmentAutomation",
    "sendAssessmentAutomation_emailAgain",
    "sendAssessment_emailAgain",
    "sendAssessmentAutomation_failedApplicantAssessmentCompleted",
    "sendAssessment_failedApplicantAssessmentCompleted",
    "jobApplicantMatch"
];
